import { useTranslation } from "react-i18next";
import ArrowButton from "./ArrowButton";
import "./ReadyScreen.scss";
import image from "./images/ready-image.jpg";

function ReadyScreen() {
  const { t, i18n } = useTranslation();
  return (
    <div className="ready-screen-container">
      <div className="mobile-hero">
        <img src={image} alt="Man using a tablet" />
      </div>
      <div className="ready-screen-white-gradient">
        <div className="image-container"></div>

        <div className="container ">
          <div className="text-container-right">
            <h1 className="blue-header">
              <div
                dangerouslySetInnerHTML={{
                  __html: t("Innovate.ready-title", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />
            </h1>
            <p>{t("Innovate.ready-first-paragraph")}</p>
            <a
              href=" https://www.avaya.com/en/contacts/?CTA=23CLD-GL-IWD-EB&TAC=23CLD-GL-IWD-EB-WEB"
              target="_blank"
              className="blue-link"
            >
              {t("Innovate.ready-link")}
            </a>
            <div className={"arrow-buttons-container-right"}>
              <ArrowButton to="/why-avaya" side="left"></ArrowButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReadyScreen;
